import { Component } from '@angular/core';

/**
 * L'impasse honnête : le navigateur refuse le cookie de session, donc la connexion ne peut pas
 * aboutir.
 *
 * <strong>Pourquoi un écran plutôt qu'un jeton dans l'URL.</strong> Le repli d'hier — remettre la
 * personne à son espace avec `?token=` — ne lui achetait qu'un quart d'heure : les quatre espaces
 * sont en `authorization_code` depuis O2.11, et le renouvellement exige le même cookie. Elle se
 * serait retrouvée déconnectée sans explication, au milieu de son travail. Le dire tout de suite est
 * plus utile, et c'est actionnable.
 *
 * <strong>Pourquoi une page et pas un toast.</strong> On y arrive depuis le formulaire, mot de passe
 * déjà accepté : le cookie témoin (`sessionCookieAccepted`) a refusé de tenir avant la remise à
 * l'espace. Un toast sur un formulaire qu'on vient de réussir dirait mal ce qui bloque ; la page a la
 * place de dire quoi changer, et son lien ramène au formulaire pour réessayer.
 */
@Component({
  templateUrl: './cookies-required.page.html',
  standalone: false,
})
export class CookiesRequiredPage {
  readonly authOrigin = window.location.origin;
}
